import { GameObject } from '../objects/gameobject';

class _GameControl {
  moveTo(x: any, y: any, z: any) {
    netGame.moveTo(x, y, z);
    return MC._moveTo(x, y);
  }

  moveToObj(gameObject: any, distance: any) {
    if (!(gameObject instanceof GameObject)) {
      console.warn('Object passed to moveToObj was not a GameObject.');
      return;
    }

    netGame.moveTo(
      gameObject.position.x,
      gameObject.position.y,
      gameObject.position.z,
      gameObject.serverObjectIdx);
    const command = MC._moveToObj(gameObject.ref, distance);
    command.on("finish", () => {
      netGame.syncPosition(MC.position.x, MC.position.y, MC.position.z);
    });
    return command;
  }

  pickupItem(gameObject: any) {
    if (!(gameObject instanceof GameObject)) {
      console.warn('Object passed to pickupItem was not a GameObject.');
      return;
    }

    const command = this.moveToObj(gameObject, undefined);
    command.on('finish', () => {
      MC.pawn.playPickupMotion(() => {
        MC.pawn.playIdleMotion();
        netGame.pickupItem(gameObject.serverObjectIdx);
      });
    });
    return command;
  }

  attackObj(gameObject: any) {
    if (!(gameObject instanceof GameObject)) {
      console.warn('Object passed to attackObj was not a GameObject.');
      return;
    }

    // Don't send the 0x798 attack-request here: the player is usually still
    // walking toward the target at click time, so the server would reject it
    // for being out of range. _AttackCmd.enter() (attack.ts) sends it once
    // we've actually arrived in melee range and are about to swing.
    return MC._attackObj(gameObject.ref);
  }

  useSkillOnTarget(gameObject: any, skillSlotNo: number, skillData: any) {
    if (!(gameObject instanceof GameObject)) {
      console.warn('Object passed to useSkillOnTarget was not a GameObject.');
      return;
    }

    const rawRange = Number(skillData?.[SKILL.RANGE]);
    const range = Number.isFinite(rawRange) && rawRange > 0
      ? rawRange / 100
      : MC.stats.getAttackDistance();
    const command = this.moveToObj(gameObject, range);
    command.on('finish', () => {
      if ((gameObject as any).isDead || gameObject.ref?.object !== gameObject) return;
      netGame.useSkillOnTarget(skillSlotNo, gameObject.serverObjectIdx);
    });
    return command;
  }
}

export const GC = new _GameControl();
